/* assets/ws_charm_bar.js */
(function () {
  // ---------- Global Charms Staging (one singleton for the whole page) ----------
  // Exposed API:
  //  - WSCB.stageBundle({ id, items:[{id,quantity,properties}], display:[{title,img,oos}], meta:{bid,...} })
  //  - WSCB.getStagedLineItems(pop=false) -> flat items[]
  //  - WSCB.peekLineItems() -> flat items[] (non-destructive)
  //  - WSCB.getStagedBundles() -> all bundles[]
  //  - WSCB.removeBundle(id)
  //  - WSCB.restageLineItems(items, meta) -> put items back after a failed add
  // Events:
  //  - document: 'wscb:staged:change'  detail: { staged: bundles[] }

  // One-time style override: keep preorder text red, and DO NOT gray out keys/images for preorder
  // Sold-out keys (continue selling OFF) get grayed out and blocked
  (function injectOnce(){
    if (document.getElementById('wscb-preorder-style')) return;
    const style = document.createElement('style');
    style.id = 'wscb-preorder-style';
    style.textContent = `
      .wscb-key--oos { opacity: 1 !important; text-decoration: none !important; }
      .wscb-key--oos .wscb-key__img { filter: drop-shadow(0 2px 4px rgba(0,0,0,.15)) !important; }
      .wscb-key__preorder, .wscb-staged__note { color:#EA6739 !important; }
      .wscb-key--soldout { opacity: .45 !important; cursor: not-allowed !important; pointer-events: auto !important; }
      .wscb-key--soldout .wscb-key__img { filter: grayscale(.6) opacity(.5) !important; }
      .wscb-key__soldout { font-size:11px; line-height:1.1; font-weight:800; color:#999; }
    `;
    document.head.appendChild(style);
  })();

  window.WSCB = window.WSCB || (() => {
    const staged = [];
    const emit = () => {
      document.dispatchEvent(new CustomEvent('wscb:staged:change', {
        detail: { staged: staged.map(b => ({ ...b, items: b.items.slice(), display: (b.display||[]).slice() })) }
      }));
    };

    return {
      stageBundle(bundle) {
        if (!bundle || !Array.isArray(bundle.items) || !bundle.items.length) return;
        staged.push(bundle);
        emit();
      },
      getStagedLineItems(pop = false) {
        const items = staged.flatMap(b => b.items);
        if (pop) { staged.length = 0; emit(); }
        return items;
      },
      peekLineItems() {
        return staged.flatMap(b => b.items);
      },
      getStagedBundles() {
        return staged.map(b => ({ ...b, items: b.items.slice(), display: (b.display||[]).slice() }));
      },
      removeBundle(id) {
        const i = staged.findIndex(b => b.id === id);
        if (i > -1) { staged.splice(i, 1); emit(); }
      },
      restageLineItems(items = [], meta = {}) {
        if (!Array.isArray(items) || !items.length) return;
        const id = (meta.id) || (crypto?.randomUUID?.() || String(Date.now()));
        staged.push({ id, items: items.map(x => ({...x})), display: meta.display || [], meta });
        emit();
      }
    };
  })();

  // ---------- Boot across theme lifecycle events ----------
  const START_EVENTS = ["DOMContentLoaded", "shopify:section:load", "shopify:section:select"];
  START_EVENTS.forEach(evt => document.addEventListener(evt, () => boot()));
  if (document.readyState !== "loading") boot();

  function boot() {
    document.querySelectorAll('.wscb[data-wscb-bid]').forEach(root => initBlock(root));
  }

  // ---------------- helpers ----------------
  function getPayload(bid) {
    const node = document.getElementById(`wscb-payload-${bid}`);
    if (!node) return {};
    try { return JSON.parse(node.textContent || "{}"); } catch { return {}; }
  }

  const uuid = () =>
    (window.crypto?.randomUUID?.() ||
      "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        const r = Math.random()*16|0, v = c === "x" ? r : (r&0x3|0x8);
        return v.toString(16);
      }));

  const toast = (m) => { try { window?.Shopify?.toast?.show?.(m); } catch {} };

  // Parse a number like "$3", "3", "3.00" out of the price note (used for staged total)
  function parsePricePerCharm(note, fallback = 3) {
    if (typeof note !== "string") return fallback;
    const m = note.replace(',', '.').match(/([0-9]+(?:\.[0-9]{1,2})?)/);
    return m ? parseFloat(m[1]) : fallback;
  }


  /* Shop-currency amounts formatted with the SHOPPER's currency code read as the wrong
   * number: a $3 charm came out as "A$3.00" for an Australian shopper, when their price is
   * about A$4.30. Every figure these builders print comes from Liquid in the shop's
   * currency, so convert with the rate Shopify publishes for the active market before
   * formatting. Shopify's own rounding for a market can differ by a few cents; this is the
   * honest amount, not a made-up one.
   */
  function __presentmentRate() {
    try {
      const r = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || "1");
      return isFinite(r) && r > 0 ? r : 1;
    } catch (e) { return 1; }
  }
  function moneyFmt(n) {
    try {
      const locale = document.documentElement.lang || "en-US";
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: (window.Shopify?.currency?.active || "USD")
      }).format((Number(n) || 0) * __presentmentRate());
    } catch {
      return `$${(+n || 0).toFixed(2)}`;
    }
  }

  // Create a staged area container under the trigger if missing
  function ensureStagedContainer(root, bid) {
    const btn = root.querySelector(`#wscb-open-${bid}`);
    if (!btn) return null;

    let wrap = root.querySelector('.wscb-staged-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'wscb-staged-wrap';
      wrap.innerHTML = `
        <style>
          #wscb-${bid} .wscb-staged-wrap{margin:12px 0 6px}
          #wscb-${bid} .wscb-staged__list{display:grid; gap:10px}
          #wscb-${bid} .wscb-staged__item{display:flex; align-items:center; justify-content:space-between; gap:10px; border:1px solid var(--wscb-border, rgba(0,0,0,.08)); border-radius:12px; padding:10px 12px; background:var(--wscb-card,#fff);}
          #wscb-${bid} .wscb-staged__thumbs{display:flex; gap:6px; align-items:center; flex-wrap:wrap}
          #wscb-${bid} .wscb-staged__thumb{width:28px; height:28px; border-radius:6px; border:1px solid rgba(0,0,0,.08); background:#fff; overflow:hidden; display:grid; place-items:center}
          #wscb-${bid} .wscb-staged__thumb img{max-width:100%; max-height:100%; object-fit:contain}
          #wscb-${bid} .wscb-staged__meta{display:flex; flex-direction:column; gap:6px; flex:1; min-width:0}
          #wscb-${bid} .wscb-staged__title{font-weight:800; font-size:13px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis}
          #wscb-${bid} .wscb-staged__price{font-size:13px; opacity:.85}
          #wscb-${bid} .wscb-staged__rm{border:1px solid var(--wscb-border, rgba(0,0,0,.12)); background:#fff; border-radius:999px; padding:6px 10px; cursor:pointer}
          #wscb-${bid} .wscb-staged__note{font-size:12px; font-weight:800;}
        </style>
        <div class="wscb-staged__list" id="wscb-staged-${bid}"></div>
      `;
      btn.insertAdjacentElement('afterend', wrap);
    }
    return wrap.querySelector(`#wscb-staged-${bid}`);
  }

  // Render all staged bundles for THIS block (filtered by meta.bid)
  function renderStagedList(root, bid, DATA) {
    const list = ensureStagedContainer(root, bid);
    if (!list) return;

    const all = window.WSCB.getStagedBundles();
    const stagedForThisBlock = all.filter(b => String(b?.meta?.bid) === String(bid));
    list.innerHTML = '';

    stagedForThisBlock.forEach(bundle => {
      const li = document.createElement('div');
      li.className = 'wscb-staged__item';
      li.dataset.stagedId = bundle.id;

      // thumbs
      const thumbs = document.createElement('div');
      thumbs.className = 'wscb-staged__thumbs';
      (bundle.display || []).forEach(ch => {
        const t = document.createElement('div');
        t.className = 'wscb-staged__thumb';
        if (ch.img) {
          t.innerHTML = `<img src="${ch.img}" alt="${ch.title || ''}">`;
        } else {
          const c = (ch.title || '').slice(0,1).toUpperCase();
          t.textContent = c || '\u2022';
        }
        thumbs.appendChild(t);
      });

      // meta (title + price + optional preorder note BELOW thumbs on its own line)
      const meta = document.createElement('div');
      meta.className = 'wscb-staged__meta';

      const title = document.createElement('div');
      title.className = 'wscb-staged__title';
      const count = (bundle.items || []).length;
      const label = (DATA?.ui?.addLabel || 'ADD TO SET').replace(/ADD TO SET/i, 'Charms');
      title.textContent = `${label} — ${count} charm${count===1?'':'s'}`;

      const price = document.createElement('div');
      price.className = 'wscb-staged__price';
      const per = parsePricePerCharm(DATA?.ui?.priceNote, 3);
      price.textContent = `${moneyFmt(per)} \u00d7 ${count} = ${moneyFmt(per * count)}`;

      meta.append(title, price);

      const anyOOS = (bundle.display || []).some(d => d && d.oos === true);
      if (anyOOS) {
        const pre = document.createElement('div');
        pre.className = 'wscb-staged__note';
        pre.textContent = DATA?.ui?.oosPreorderNote || " ";
        meta.appendChild(pre); // <<— new line under charms images (meta is under thumbs)
      }

      // remove
      const rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'wscb-staged__rm';
      rm.textContent = 'Delete';

      // Build a descriptive SR label (reuse existing `count` + `label` from above)
      const letters = (bundle.display || [])
        .map(d => (d?.title || '').trim())
        .filter(Boolean)
        .join(', ');

      rm.setAttribute(
        'aria-label',
        letters
          ? `Remove ${label} set — ${count} charm${count === 1 ? '' : 's'}: ${letters}`
          : `Remove ${label} set — ${count} charm${count === 1 ? '' : 's'}`
      );

      rm.addEventListener('click', () => {
        window.WSCB.removeBundle(bundle.id);
      });


      li.append(thumbs, meta, rm);
      list.appendChild(li);
    });

    // Update trigger label when at least one staged
    const openBtn = root.querySelector(`#wscb-open-${bid}`);
    if (openBtn) {
      if (stagedForThisBlock.length > 0) {
        openBtn.textContent = DATA?.ui?.btnHasStaged || 'ADD ANOTHER SET OF CHARMS';
      } else {
        openBtn.textContent = DATA?.ui?.btnDefault || (DATA?.ui?.heading || 'ADD CHARM PERSONALIZATION');
      }
    }
  }

  // ---------------- per-block init ----------------
  async function initBlock(root) {
    if (root.__wscbMounted) return;
    const bid = root.dataset.wscbBid;
    if (!bid) return;
    root.__wscbMounted = true;

    const DATA = getPayload(bid);
    const pricePerCharm = parsePricePerCharm(DATA?.ui?.priceNote, 3);

    // elements
    const $ = id => document.getElementById(id);
    const el = {
      open:   $(`wscb-open-${bid}`),
      modal:  $(`wscb-modal-${bid}`),
      strap:  $(`wscb-strap-${bid}`),
      status: $(`wscb-strap-status-${bid}`),
      count:  $(`wscb-count-${bid}`),
      clear:  $(`wscb-clear-${bid}`),
      colors: $(`wscb-colors-${bid}`),
      keygrid:$(`wscb-keygrid-${bid}`),
      add:    $(`wscb-add-${bid}`),
    };
    if (!el.open || !el.modal) return;

    // ensure closed initially
    try { el.modal.removeAttribute("open"); } catch {}

    // push style variables from payload so theme colors "stick"
    applyStyleVars(el.modal, DATA?.styles || {});

    // per-block state
    const S = { strap: [], currentColorIndex: 0 };
    const setCount = () => { if (el.count) el.count.textContent = String(S.strap.length); updateCTA(); };

    // listen for global staged changes to keep this block's list in sync
    const onStageChange = () => renderStagedList(root, bid, DATA);
    document.addEventListener('wscb:staged:change', onStageChange);

    // ---------- open/close ----------
    function openModal() {
      try {
        if (typeof el.modal.showModal === "function" && !el.modal.open) {
          el.modal.showModal();
        } else {
          el.modal.setAttribute("open", "open");
        }
      } catch {
        el.modal.setAttribute("open", "open");
      }
      el.open.setAttribute("aria-expanded", "true");

      const closeBtn = el.modal.querySelector("[data-close]");

      el.modal.style.display = "grid";
      el.modal.style.position = "fixed";
      el.modal.style.zIndex = "9999";
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";

      startFocusTrap();
      focusFirstInModal();

    }

    function closeModal() {

      stopFocusTrap();
      const back = lastFocused && document.contains(lastFocused) ? lastFocused : el.open;
      back?.focus?.();


      try {
        if (el.modal.open && typeof el.modal.close === "function") {
          el.modal.close();
        }
      } catch {
        // no-op fallback
      }

      // Always remove open state (covers fallback paths)
      el.modal.removeAttribute("open");

      // Reset visual styles
      el.modal.style.display = "";
      el.modal.style.position = "";
      el.modal.style.zIndex = "";

      // Restore page scroll
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";

      // ARIA + focus return
      el.open.setAttribute("aria-expanded", "false");
      if (el.open && document.contains(el.open)) el.open.focus();
    }

    // ---------- style vars ----------
    function applyStyleVars(scope, vars){
      if (!scope) return;
      const map = {
        surface:"--wscb-surface",
        card:"--wscb-card",
        border:"--wscb-border",
        strapBg:"--wscb-strap-bg",
        strapBorder:"--wscb-strap-border",
        chipBg:"--wscb-chip-bg",
        chipText:"--wscb-chip-text",
        heading:"--wscb-heading",
        body:"--wscb-body",
        keyBg:"--wscb-key-bg",
        keyBorder:"--wscb-key-border",
        keyLetter:"--wscb-key-letter",
        ctaBg:"--wscb-cta-bg",
        ctaText:"--wscb-cta-text",
        preview:"--wscb-preview"
      };
      Object.keys(map).forEach(k=>{
        if (vars[k]) scope.style.setProperty(map[k], vars[k]);
      });
    }

    // ---------- preview swatches (strap color) ----------
    function bindPreviewSwatches() {
      const row = el.modal.querySelector('.wscb-preview-swatches');
      if (!row) return;

      const nodes = Array.from(row.querySelectorAll('.sw'));
      if (!nodes.length) return;

      // ---- helpers ----
      const setActive = (idx) => {
        nodes.forEach((btn, i) => {
          const isActive = i === idx;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
          btn.tabIndex = isActive ? 0 : -1;
        });
      };

      const applyColor = (btn) => {
        const hex = getComputedStyle(btn).getPropertyValue('--sw').trim();
        el.modal.style.setProperty(
          '--wscb-preview',
          hex || DATA?.styles?.preview || '#47B276'
        );
      };

      // ---- mouse / touch ----
      nodes.forEach((btn, i) => {
        btn.addEventListener('click', () => {
          applyColor(btn);
          setActive(i);
          btn.focus();
        });
      });

      // ---- keyboard navigation (radio pattern) ----
      row.addEventListener('keydown', (e) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;

        e.preventDefault();

        const current = nodes.findIndex(
          n => n.getAttribute('aria-checked') === 'true'
        );
        const dir = (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 1;
        const next = (current + dir + nodes.length) % nodes.length;

        applyColor(nodes[next]);
        setActive(next);
        nodes[next].focus();
      });

      // ---- initialize first swatch ----
      setActive(0);
      applyColor(nodes[0]);
    }

    // ---------- color pills ----------
    function bindColorPills() {
      if (!el.colors) return;

      const group = el.colors; // #wscb-colors-{bid} (you already set role="radiogroup" in Liquid)
      const pills = Array.from(group.querySelectorAll(".wscb-color"));
      if (!pills.length) return;

      // Ensure each pill has radio semantics
      pills.forEach((btn, i) => {
        btn.setAttribute("role", "radio");
        btn.setAttribute("aria-checked", i === 0 ? "true" : "false");
        btn.tabIndex = i === 0 ? 0 : -1;

        // Give each radio a clear accessible name (belt + suspenders)
        // Uses visible text from the pill
        const labelText = (btn.textContent || "").trim().replace(/\s+/g, " ");
        if (labelText) btn.setAttribute("aria-label", `Charm color: ${labelText}`);
      });

      const activate = (idx, { focus = false } = {}) => {
        pills.forEach((btn, i) => {
          const on = i === idx;
          btn.classList.toggle("is-active", on);
          btn.setAttribute("aria-checked", on ? "true" : "false");
          btn.tabIndex = on ? 0 : -1;
        });

        S.currentColorIndex = idx;
        renderKeys();

        if (focus) pills[idx].focus();
      };

      // Click selects the radio
      pills.forEach((btn, idx) => {
        btn.addEventListener("click", () => activate(idx, { focus: true }));
      });

      // Arrow keys move selection (standard radio pattern)
      group.addEventListener("keydown", (e) => {
        if (!["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(e.key)) return;

        e.preventDefault();

        const current = pills.findIndex((b) => b.getAttribute("aria-checked") === "true");
        const dir = (e.key === "ArrowLeft" || e.key === "ArrowUp") ? -1 : 1;
        const next = (current + dir + pills.length) % pills.length;

        activate(next, { focus: true });
      });

      // Initialize (keep your default as first)
      activate(0);
    }


    // ---------- render strap ----------
    function renderStrap() {
      if (!el.strap) return;

      // Remember focus so removal doesn't strand keyboard users
      const activeEl = document.activeElement;
      const activeRemoveBtn = activeEl && activeEl.classList?.contains("wscb-strap__rm") ? activeEl : null;
      const activeIndex = activeRemoveBtn
        ? parseInt(activeRemoveBtn.getAttribute("data-idx") || "-1", 10)
        : -1;

      el.strap.innerHTML = "";

      S.strap.forEach((it, i) => {
        const wrap = document.createElement("li");
        wrap.className = "wscb-strap__charm";
        wrap.setAttribute("role", "listitem");



        const img = document.createElement("img");
        img.className = "wscb-strap__img";
        img.alt = it.title || "";
        img.src = it.img || "";

        const rm = document.createElement("button");
        rm.type = "button";
        rm.className = "wscb-strap__rm";
        rm.textContent = "\u00d7";


        rm.setAttribute("aria-label", `Remove charm ${it.title || "item"}`);
        rm.setAttribute("data-idx", String(i));

        rm.addEventListener("click", (ev) => {
          ev.preventDefault();
          ev.stopPropagation();

          // Remove item
          S.strap.splice(i, 1);
          renderStrap();
          setCount();
          announceStrap();

          const remaining = S.strap.length;
          const nextIndex = Math.min(i, remaining - 1);
          const prevIndex = Math.max(i - 1, 0);

          const nextBtn = el.strap.querySelector(`.wscb-strap__rm[data-idx="${nextIndex}"]`);
          const prevBtn = el.strap.querySelector(`.wscb-strap__rm[data-idx="${prevIndex}"]`);

          if (remaining > 0) {
            (nextBtn || prevBtn)?.focus();
          } else {
            el.clear?.focus?.();
          }
        });

        wrap.append(img, rm);
        el.strap.appendChild(wrap);
      });

      // If focus was on a remove button, try to keep it on the "same" index after re-render
      if (activeIndex >= 0) {
        const remaining = S.strap.length;
        if (remaining > 0) {
          const idx = Math.min(activeIndex, remaining - 1);
          const btn = el.strap.querySelector(`.wscb-strap__rm[data-idx="${idx}"]`);
          btn && btn.focus();
        } else {
          el.clear?.focus?.();
        }
      }
    }


    // ---------- render keyboard ----------
    function renderKeys(){
      if (!el.keygrid) return;
      el.keygrid.innerHTML = "";

      const color = DATA.charms?.[S.currentColorIndex];
      if (!color) return;

      color.variants.forEach(v=>{
        const b = document.createElement("button");
        b.type = "button";
        b.className="wscb-key";
        b.setAttribute("role", "listitem");

        // Sold out = variant unavailable (continue selling OFF + no stock) → block completely
        const isSoldOut = !v.available;
        // Preorder = variant available but inventory depleted (continue selling ON) → allow
        const isPreorder = v.available && (typeof v.qty === "number" && v.qty <= 0);

        if (isSoldOut) { b.classList.add("wscb-key--soldout"); }
        else if (isPreorder) { b.classList.add("wscb-key--oos"); }

        const box = document.createElement("div");
        box.className = "wscb-key__box";

        if (v.image) {
          const im = document.createElement("img");
          im.className = "wscb-key__img";
          im.alt = v.title || "";
          im.src = v.image;
          box.appendChild(im);
        } else {
          const tile = document.createElement("span");
          tile.className = "wscb-key__tile";
          tile.textContent = (v.title || "").slice(0,1).toUpperCase();
          box.appendChild(tile);
        }

        const cap = document.createElement("span");
        cap.className = "wscb-key__label";
        cap.textContent = v.title || "Variant";

        b.setAttribute(
          "aria-label",
          isSoldOut
            ? `${v.title || "Variant"} — Out of stock`
            : `Add charm ${v.title || "Variant"}${isPreorder ? `. ${DATA?.ui?.oosPreorderNote || "Pre-order"}` : ""}`
        );

        b.append(box, cap);

        // Sold out note (gray, blocked)
        if (isSoldOut) {
          const note = document.createElement("span");
          note.className = "wscb-key__soldout";
          note.textContent = "Out of stock";
          b.appendChild(note);
        }
        // Preorder note BELOW the image and label (red)
        else if (isPreorder) {
          const note = document.createElement("span");
          note.className = "wscb-key__preorder";
          note.textContent = DATA?.ui?.oosPreorderNote || " ";
          b.appendChild(note);
        }

        b.addEventListener("click", ()=>{
          // Block sold-out charms (continue selling OFF)
          if (isSoldOut) { return; }
          if (S.strap.length >= (DATA.maxChars||12)) { toast(DATA?.ui?.maxMsg || "Max charms reached"); return; }
          // Allow clicking when preorder (continue selling ON)
          S.strap.push({ variantId: v.id, title: v.title, img: v.image || "", oos: isPreorder });
          renderStrap(); setCount();
          announceStrap();
          ensureStrapEdgeScroll();
        });


        el.keygrid.appendChild(b);
      });
    }

    // Keep strap scrolled to the end as people add charms
    function ensureStrapEdgeScroll(){
      const bar = el.strap?.closest('.wscb-strap')?.querySelector('.wscb-strap__bar');
      if (!bar) return;
      requestAnimationFrame(()=>{ bar.scrollLeft = bar.scrollWidth; });
    }

    // ---------- CTA live price ----------
    function updateCTA(){
      if (!el.add) return;
      const count = S.strap.length;
      const total = count * pricePerCharm;
      let sub = el.add.querySelector(".wscb-cta__sub");
      if (!sub) {
        sub = document.createElement("span");
        sub.className = "wscb-cta__sub";
        el.add.appendChild(sub);
      }
      if (count > 0){
        sub.textContent = `${count} \u00d7 ${moneyFmt(pricePerCharm)} = ${moneyFmt(total)}`;
      } else {
        sub.textContent = DATA?.ui?.ctaSub || "";
      }
    }

    // ---------- Announce strap screen reader ----------
    function announceStrap() {
      if (!el.status) return;

      const max = DATA?.maxChars || 12;
      const count = S.strap.length;

      if (count === 0) {
        el.status.textContent = `No charms selected. ${count} of ${max}.`;
        return;
      }

      const names = S.strap
        .map(ch => (ch.title || "").trim())
        .filter(Boolean);

      const list = names.length ? names.join(", ") : "selected charms";
      el.status.textContent = `Selected charms: ${list}. ${count} of ${max}.`;
    }


    // ----- Focus trap -----
    let lastFocused = null;
    let trapHandler = null;

    function getFocusable(container) {
      if (!container) return [];
      return Array.from(
        container.querySelectorAll(
          'a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, iframe, object, embed, [contenteditable], [tabindex]:not([tabindex="-1"])'
        )
      ).filter(el => {
        // must be visible
        const r = el.getBoundingClientRect();
        return (r.width > 0 || r.height > 0) && getComputedStyle(el).visibility !== "hidden";
      });
    }

    function startFocusTrap() {
      lastFocused = document.activeElement;

      trapHandler = (e) => {

        if (e.key === "Escape") {
          e.preventDefault();      // prevent weird double-handling
          e.stopPropagation();
          closeModal();
          return;
        }

        if (e.key !== "Tab") return;

        const focusables = getFocusable(el.modal);
        if (!focusables.length) {
          e.preventDefault();
          el.modal.focus?.();
          return;
        }

        const first = focusables[0];
        const last  = focusables[focusables.length - 1];

        // If focus somehow left modal, bring it back
        if (!el.modal.contains(document.activeElement)) {
          e.preventDefault();
          first.focus();
          return;
        }

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };

      // capture = true so we catch Tab before theme scripts move focus
      document.addEventListener("keydown", trapHandler, true);
    }

    function stopFocusTrap() {
      if (trapHandler) {
        document.removeEventListener("keydown", trapHandler, true);
        trapHandler = null;
      }
    }

    function focusFirstInModal() {
      const focusables = getFocusable(el.modal);
      (focusables[0] || el.modal.querySelector("[data-close]") || el.modal).focus?.();
    }


    // ---------- events ----------
    el.open.addEventListener("click", (e)=>{ e.preventDefault(); openModal(); });
    el.modal.querySelectorAll("[data-close]").forEach(b => b.addEventListener("click", closeModal));
    el.modal.addEventListener("cancel", (e)=>{ e.preventDefault(); closeModal(); });
    // Close only when the user *pointer-clicks* the backdrop (mouse/touch/pen)
    el.modal.addEventListener("pointerdown", (e) => {
      if (e.target !== el.modal) return;
      if (e.pointerType === "mouse" && e.button !== 0) return;

      closeModal();
    });

    el.clear?.addEventListener("click", ()=>{
      S.strap = []; renderStrap(); setCount();announceStrap();
      announceStrap();
      const bar = el.strap?.closest('.wscb-strap')?.querySelector('.wscb-strap__bar');
      if (bar) bar.scrollLeft = 0;
    });


    // ---------- Stage or Add-to-cart ----------
    el.add?.addEventListener("click", async ()=>{
      if (!S.strap.length) { alert(DATA?.ui?.pickOneMsg || "Pick at least one charm"); return; }

      // Notify debugging hooks if any
      try {
        const stagedDetail = { bid, strap: [...S.strap] };
        window.dispatchEvent(new CustomEvent("wscb:saved", { detail: stagedDetail }));
        document.dispatchEvent(new CustomEvent("wscb:saved", { detail: stagedDetail }));
      } catch {}

      const preorderNote = DATA?.ui?.oosPreorderNote || " ";

      if (DATA.stageOnly === true) {
        // Build a UNIVERSAL bundle that Buy Buttons can later add with /cart/add.js
        const bundleId    = uuid();
        const bundleTitle = (DATA.bundleTitlePrefix || "Charms") + " — Bundle";

        const items = S.strap.map((ch, idx) => ({
          id: String(ch.variantId),
          quantity: 1,
          properties: {
            bundleId,
            bundleParentVariantId: DATA.parentVariantGid || "",
            bundleTitle,
            // Optional child attributes used by cart transform
            _Letter: (ch.title || "").trim(),
            _OrderIndex: String(idx),
            _IsPreorder: ch.oos ? "1" : "0",
            _PreorderNote: ch.oos ? preorderNote : ""
          }
        }));

        // Separate light display data (for thumbnails/labels in the staged UI)
        const display = S.strap.map(ch => ({ title: ch.title, img: ch.img || "", oos: !!ch.oos }));

        // Save into the global stage with a back-reference to this block
        window.WSCB.stageBundle({
          id: bundleId,
          items,
          display,
          meta: {
            bid,
            count: items.length,
            pricePerCharm,
            bundleTitle
          }
        });

        toast(DATA?.ui?.toastAdded || "Saved!");
        closeModal();

        // Reset working strap for next bundle
        S.strap = [];
        renderStrap(); setCount();announceStrap();
        return; // do NOT add to cart now
      }

      // Otherwise: add directly to cart now
      const directBundleId    = uuid();
      const directBundleTitle = (DATA.bundleTitlePrefix || "Charms") + " — Bundle";
      try {
        for (const [idx, ch] of S.strap.entries()){
          const f = new FormData();
          f.append("id", String(ch.variantId));
          f.append("quantity", "1");
          f.append("properties[bundleId]", directBundleId);
          f.append("properties[bundleParentVariantId]", DATA.parentVariantGid || "");
          f.append("properties[bundleTitle]", directBundleTitle);

          // Optional child attributes
          f.append("properties[_Letter]", (ch.title || "").trim());
          f.append("properties[_OrderIndex]", String(idx));
          if (ch.oos) {
            f.append("properties[_IsPreorder]", "1");
            f.append("properties[_PreorderNote]", preorderNote);
          }

          const res = await fetch("/cart/add.js", { method:"POST", headers:{ "Accept":"application/json" }, body: f });
          if (!res.ok) throw new Error(await res.text());
        }
        toast(DATA?.ui?.toastAdded || "Bundle added!");
        closeModal();
        if (DATA.goToCart) location.href = "/cart";
        S.strap = [];
        renderStrap(); setCount();announceStrap();
      } catch (e){
        console.error("[wscb] add bundle failed:", e);
        alert(DATA?.ui?.toastError || "Add to cart failed. See console for details.");
      }
    });

    // ---------- boot ----------
    bindPreviewSwatches();
    bindColorPills();
    renderKeys();
    renderStrap();
    setCount();
    announceStrap();

    // First render (pull whatever is already staged for this block)
    renderStagedList(root, bid, DATA);

    // Optional: allow external open via event
    window.addEventListener('wscb:open', (ev) => {
      const targetBid = ev?.detail?.bid;
      if (String(targetBid) === String(bid)) openModal();
    });

    // expose for debugging
    function setStrap(items) {
      S.strap = (items || []).map(it => ({
        variantId: it.variantId,
        title: it.title || "",
        img: it.img || "",
        oos: !!it.oos
      }));
      renderStrap();
      setCount();
      announceStrap();
    }

    window.__wscb = window.__wscb || {};
    window.__wscb[bid] = {
      open: openModal,
      close: closeModal,
      setStrap: setStrap,
      state: S,
      els: el,
      data: DATA
    };
  }
})();
